import axios from 'axios';
import apiConfig from '../config/apiConfig';

const API_BASE_URL = apiConfig.BASE_URL;

const LANDING_REFERRER_KEY = 'blogify_landing_referrer';

function getLandingReferrer() {
  if (typeof window === 'undefined') return null;

  try {
    const stored = sessionStorage.getItem(LANDING_REFERRER_KEY);
    if (stored) return stored || null;

    const ref = document.referrer?.trim();
    if (!ref) return null;

    try {
      const refHost = new URL(ref).hostname.replace(/^www\./i, '').toLowerCase();
      const siteHost = window.location.hostname.replace(/^www\./i, '').toLowerCase();
      if (refHost === siteHost) return null;
    } catch {
      // keep raw referrer
    }

    sessionStorage.setItem(LANDING_REFERRER_KEY, ref);
    return ref;
  } catch {
    return document.referrer || null;
  }
}

function extractArticleSlug(path = '') {
  const match = String(path).match(/\/article\/([^/?#]+)/i);
  return match ? decodeURIComponent(match[1]) : null;
}

/**
 * Record a public page view with landing referrer for admin traffic analytics.
 */
export async function trackPublicPageView({ path, title } = {}) {
  if (!path || typeof window === 'undefined') return;

  const articleSlug = extractArticleSlug(path);
  const referrer = getLandingReferrer();

  try {
    await axios.post(
      `${API_BASE_URL}/visitors/track`,
      {
        path,
        referrer,
        articleSlug,
        query: { title: title || document.title || undefined },
      },
      { withCredentials: true }
    );
  } catch {
    // Non-blocking analytics
  }
}
